<template>
  <div class="withShadow">
    <pageHeader />
    <div class="packages section-pad bg-grayImg">
      <div class="container">
        <contactComp
          :loader="loader"
          :logo="logo"
          :email="email"
          :phone="phone"
          :socials="socials"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
// imports
import pageHeader from "../components/pageHeader.vue";
import contactComp from "../components/dashboard/contactComp.vue";
import { onMounted , ref } from "vue";
import axios from "axios";

// reactive state
const loader = ref(false);
const logo = ref("");
const email = ref("");
const phone = ref("");
const socials = ref([]);

// functions
function getContact() {
  loader.value = true;
  axios
    .get("/socials")
    .then((response) => {
      logo.value = response.data.data.logo;
      email.value = response.data.data.email;
      phone.value = response.data.data.phone;
      socials.value = response.data.data.socials;
      loader.value = false;
    });
}
// lifecycle hooks
onMounted(() => {
  getContact();
});
</script>
